'use strict';

var isServer = typeof window === 'undefined';

/**
 * 给某个 query 参数 encodeURIComponent
 *
 * @param {string} key 需要 encode 的键名
 * @param {string} url 需要替换的 url，默认用 location.href
 * @return {string} 返回替换后的完整 url
 */
function encodeQueryParameter(key, url) {
  if (isServer) return '';
  if (!url) url = location.href;

  var re = new RegExp('([?&])' + key + '=(.*?)(&|$)', 'i');
  if (url.match(re)) {
    return url.replace(re, function (match, p1, p2, p3) {
      return p1 + key + '=' + encodeURIComponent(p2) + p3;
    });
  }

  return url;
}

module.exports = encodeQueryParameter;